import Noty from 'noty';
import CustomValidation from './custom-validation';

const Utils = {
    init() {
        this._jLoader = $('.loader');
        CustomValidation.init();
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
        });
    },
    sendRequest(config) {
        const me = this;
        if (config.skipLoader == undefined || config.skipLoader == false) {
            this.showLoader(true);
        }
        var ajaxOptions = {
            url: config.url,
            type: config.type ?
                config.type : 'POST',
            dataType: 'JSON',
            data: config.data != undefined ?
                config.data : null,
        };

        if (config.isFile) {
            ajaxOptions.cache = false;
            ajaxOptions.contentType = false;
            ajaxOptions.processData = false;
        }

        $.ajax(ajaxOptions).done(function(response) {
            if (config.onDone) {
                config.onDone(response);
            }

        }).fail(function() {
            if (config.onFail) {
                config.onFail();
            }

        }).always(function() {
            if (config.skipLoader == undefined || config.skipLoader == false) {
                me.showLoader(false);
            }

            if (config.onAlways) {
                config.onAlways();
            }
        });
    },
    notify(notifyObj) {
        if (notifyObj && notifyObj.message) {
            new Noty({
                type: notifyObj.type ? notifyObj.type : 'warning',
                text: notifyObj.message,
                theme: 'mint',
                layout: 'topRight',
                timeout: 5000,
                animation: {
                    open: 'noty_effects_open', // Animate.css class names
                    close: 'noty_effects_close', // Animate.css class names
                },
            }).show();

        }
    },
    getValidationConfig(config) {
        var defaultConfig = {
            highlight: function(element, errorClass) {
                errorClass;
                $(element).addClass('has-error');
                $(element).parent().find('input').addClass('has-error');
            },
            unhighlight: function(element, errorClass) {
                errorClass;
                $(element).removeClass('has-error');
            },
            errorPlacement: function(error, element) {
                // error.insertAfter(element);
                if (element.attr('name') == 'checkbox_group[]') {
                    error.insertAfter('#checkbox-error');
                } else {
                    var allChilds = element.parent().children();
                    var lastChild = allChilds[allChilds.length - 1];

                    error.insertAfter(lastChild);
                }
            },
            submitHandler: function(form) {
                var jForm = $(form);
                jForm.find('input[type="submit"]').addClass('disabled');
                form.submit();
                jForm.find('input[type="submit"]').removeClass('disabled');
                $('.loading').addClass('g-hidden');
            },
        };

        return $.extend(defaultConfig, config);
    },
    showLoader(bShow) {
        if (bShow === undefined) {
            this._jLoader.fadeIn();
        } else {
            this._jLoader[bShow ? 'fadeIn' : 'fadeOut']();
        }
    },

}
export default Utils;


// WEBPACK FOOTER //
// ./scripts/util/utils.js